/**
 * Init last posts slider in front-page.php
 */

if( document.querySelector("#last-posts") ) {

  const lastPosts = new Splide("#last-posts", {
    type: "slide",
    perPage: 2,
    perMove: 1,
    pagination: false,
    arrows: true,
    gap: '9.375rem',
    breakpoints: {
      1480: {
        gap: '5rem',
      },
      1280: {
        gap: '1.5rem',
      },
      890: {
        destroy: true,
        arrows: false,
      },
    }
  });

  lastPosts.mount();

}
